export default __webpack_public_path__ + "static/media/hotel_100px.625d354b.svg";